export default "__VITE_ASSET__CKiwKXgx__"